import React, { Component } from 'react'
import validator from 'validator';

var FormValidator = {}

FormValidator.required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return 'require';
  }
};

FormValidator.email = (value) => {
  if (!validator.isEmail(value)) {
    return `${value} is not a valid email.`
  }
};

FormValidator.lt = (value, props) => {
  // get the maxLength from component's props
  if (value.toString().trim().length > props.maxLength) {
    // Return jsx
    return <span className="error">The value exceeded {props.maxLength} symbols.</span>
  }
};

FormValidator.password = (value, props, components) => {
  if (value !== components['confirm'][0].value) {
    return <span className="error">Passwords are not equal.</span>
  }
};

export default FormValidator;



// WEBPACK FOOTER //
// ./src/Validators/form_validator.js